// This file is auto-generated by Laravel Wayfinder.
// Do not edit this file directly, any changes will be overwritten.

import { formSafeOptions, queryParams, type RouteDefinition, type RouteFormDefinition, type RouteQueryOptions } from "./../../../../index";

/**
 * @see \App\Http\Controllers\Release\ReleaseShowController::__invoke
 * @see /home/forge/mycommunitysite.co/releases/20261103214936/app/Http/Controllers/Release/ReleaseShowController.php:15
 * @route "/app-release"
 */
const ReleaseShowController = (options?: RouteQueryOptions): RouteDefinition<"get"> => ({
    url: ReleaseShowController.url(options),
    method: "get",
})

ReleaseShowController.definition = {
    methods: ["get","head"],
    url: "/app-release",
} satisfies RouteDefinition<["get","head"]>

/**
 * @see \App\Http\Controllers\Release\ReleaseShowController::__invoke
 * @see /home/forge/mycommunitysite.co/releases/20261103214936/app/Http/Controllers/Release/ReleaseShowController.php:15
 * @route "/app-release"
 */
ReleaseShowController.url = (options?: RouteQueryOptions) => {
    return ReleaseShowController.definition.url + queryParams(options)
}

/**
 * @see \App\Http\Controllers\Release\ReleaseShowController::__invoke
 * @see /home/forge/mycommunitysite.co/releases/20261103214936/app/Http/Controllers/Release/ReleaseShowController.php:15
 * @route "/app-release"
 */
ReleaseShowController.get = (options?: RouteQueryOptions): RouteDefinition<"get"> => ({
    url: ReleaseShowController.url(options),
    method: "get",
})

/**
 * @see \App\Http\Controllers\Release\ReleaseShowController::__invoke
 * @see /home/forge/mycommunitysite.co/releases/20261103214936/app/Http/Controllers/Release/ReleaseShowController.php:15
 * @route "/app-release"
 */
ReleaseShowController.head = (options?: RouteQueryOptions): RouteDefinition<"head"> => ({
    url: ReleaseShowController.url(options),
    method: "head",
})



/**
 * @see \App\Http\Controllers\Release\ReleaseShowController::__invoke
 * @see /home/forge/mycommunitysite.co/releases/20261103214936/app/Http/Controllers/Release/ReleaseShowController.php:15
 * @route "/app-release"
 */
const ReleaseShowControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<"get"> => ({
    action: ReleaseShowController.url(options),
    method: "get",
})

/**
 * @see \App\Http\Controllers\Release\ReleaseShowController::__invoke
 * @see /home/forge/mycommunitysite.co/releases/20261103214936/app/Http/Controllers/Release/ReleaseShowController.php:15
 * @route "/app-release"
 */
ReleaseShowControllerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<"get"> => ({
    action: ReleaseShowController.url(options),
    method: "get",
})

/**
 * @see \App\Http\Controllers\Release\ReleaseShowController::__invoke
 * @see /home/forge/mycommunitysite.co/releases/20261103214936/app/Http/Controllers/Release/ReleaseShowController.php:15
 * @route "/app-release"
 */
ReleaseShowControllerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<"get"> => ({
    action: ReleaseShowController.url(formSafeOptions("head", options)),
    method: "get",
})



ReleaseShowController.form = ReleaseShowControllerForm

export default ReleaseShowController